



import { AccessLevel } from '@/modules/access-policy/constants/access-levels.constants';
import { computed, defineComponent } from '@vue/composition-api';
import { Icon } from '@iconify/vue2';
import * as R from 'ramda';
import { match } from 'ts-pattern';

export default defineComponent({
    name: 'AccessLevelDynamicBadgeCompact',
    props: {
        accessLevel: { type: String, required: true },
        withColour: { type: Boolean, default: false },
    },
    components: { Icon },
    setup(props) {
        const accessLevelIcon = computed(() => {
            if (R.isNil(props.accessLevel)) return;

            switch (props.accessLevel) {
                case AccessLevel.Private:
                    return 'material-symbols:lock'; // lock
                case AccessLevel.OrganisationLevel:
                    return 'bi:building-fill'; // building
                case AccessLevel.SelectiveSharing:
                    return 'bi:building-fill-exclamation'; //building cog
                case AccessLevel.Restricted:
                    return 'fluent:people-settings-24-filled'; // partial
                case AccessLevel.Public:
                    return 'material-symbols:public'; // globe
                default:
                    return null;
            }
        });

        const accessLevelColour = computed(() => {
            if (R.isNil(props.accessLevel)) return;

            return match(props.accessLevel)
                .with(AccessLevel.Private, () => 'text-red-600')
                .with(AccessLevel.OrganisationLevel, () => 'text-blue-600')
                .with(AccessLevel.SelectiveSharing, () => 'text-indigo-600')
                .with(AccessLevel.Restricted, () => 'text-orange-600')
                .with(AccessLevel.Public, () => 'text-green-600')
                .otherwise(() => 'text-neutral-400');
        });

        return {
            AccessLevel,
            accessLevelIcon,
            accessLevelColour,
        };
    },
});
